/**
 * Encabezado de una seccion de la portada, con su enlace de "ver todo".
 *
 * Cada seccion es un `<section>` con su `<h2>`: la portada queda como un indice
 * legible tanto para un lector de pantalla como para un robot, en vez de una
 * sucesion de bloques sin nombre.
 */
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { Icono } from '../comunes/Icono';

export interface SeccionInicioProps {
  /** Base del id del encabezado: la seccion se etiqueta con el. */
  id: string;
  titulo: string;
  bajada?: string;
  enlace?: { texto: string; ruta: string };
  children: ReactNode;
}

export function SeccionInicio({ id, titulo, bajada, enlace, children }: SeccionInicioProps) {
  return (
    <section className="seccion" aria-labelledby={id}>
      <div className="seccion-cab">
        <div>
          <h2 id={id}>{titulo}</h2>
          {bajada !== undefined ? <p className="sub">{bajada}</p> : null}
        </div>
        {enlace !== undefined ? (
          <Link className="enlace-mas" to={enlace.ruta}>
            {enlace.texto}
            <Icono nombre="flecha" />
          </Link>
        ) : null}
      </div>
      {children}
    </section>
  );
}
